const customizableTitles = {
    //these will need to be updated with the custom fields from the customization json object on activation
    overview_title: 'Overview',
    products_title: 'Products',
    live_tasks_title: 'Task Requirements',
    upload_files_title: 'Upload Files',
    products_shipping_information_title: 'Shipping Information',
    tasks_step_title: 'Tasks',
    additional_information_title: 'Additional Information',
    brand_assets_title: 'Brand Assets',
    content_rights_title: 'Content Rights',
    networks_title: 'Networks',
    campaign_date_start_title: 'Submit Proposal Start',
    campaign_date_end_title: 'Submit Proposal End',
    content_date_start_title: 'Deliver Content Start',
    content_date_end_title: 'Deliver Content End',
    campaign_proposal_submitted_date_header: 'Submitted on',
    campaign_proposal_accepted_date_header: 'Joined on',
    campaign_proposal_declined_date_header: 'Last Updated',
    get_started_button_text: 'Get Started',
    submitted_title: "You're almost ready to begin!",
    live_payment_title: 'Payments'
};
const customizableText = {
    products_description: 'Select the products according to your terms.',
    additional_information_description: 'Please enter any other additional required or optional information.',
    live_task_description: 'Include the following in your post',
    live_task_instructions: '',
    live_connect_networks_description: "Connecting your networks gives us permission to automatically pull in your content (such as Instagram stories and posts) so that you don't have to manually upload your tasks. This also allows us to see stats such as comments, shares, impressions, and likes on your post.",
    content_rights_description: 'You must agree to these content rights to participate.',
    submitted_message: "Thanks for your interest in our campaign. Your information has been sent. You should hear back from us soon.\n\n Don't forget to bookmark this link so you can revisit the campaign details later!",
    brand_assets_description: 'Please be sure to review these important documents.',
    products_shipping_information_description: '',
    live_payment_description: '',
    live_commission_payments_description: "You'll be paid for every time a purchase is made with your affiliate link or discount code.",
    live_contract_payments_description: "You'll be paid a fixed amount for completing your contract.",
    live_contract_payments_description_per_task: "You'll be paid per task for completing your contract.",
    live_contract_payments_description_proposed: 'Please propose a price for completing your contract.',
    products_out_of_stock: "Looks like we're all out of stock! If you think this was a mistake, please email us."
};
export { customizableTitles, customizableText };
